export enum LegacyColor {
  Black = '#000000',
  Blue = '#326bff',
  Gray = '#e7e7e7',
  LightBlue = '#c4e0fd',
  LightGray = '#f5f5f5',
  LightOrange = '#ef8d5d',
  LightPurple = '#ab89e1',
  LightTeal = '#b3fff8',
  LightYellow = '#ffd953',
  BlueExtraLight = '#dfeeff',
  Orange = '#f56d29',
  Purple = '#5a378a',
  Teal = '#6afdef',
  UIGray = '#a0a0a0',
  UIError = '#fc5b3f',
  UISuccess = '#6afdb3',
  UIWarning = '#ffd935',
  White = '#ffffff',
  Yellow = '#f5c000',
  Red = '#ff0000',
  Transparent = 'transparent',
}
